export var SDK_VERSION = '6.7.0';
//# sourceMappingURL=version.js.map